import { Center, Grid, GridItem, Text } from '@chakra-ui/react'
import TableOrder from 'components/Tables/TableOrder'
import React, { useContext, useEffect, useState } from 'react'
import { Title } from 'styled/Title'
import TBodyFormatSRT from './TBody/TBodyFormatSRT'
import { useSelector } from 'react-redux'
import queryString from 'query-string'
import { useLocation, useNavigate } from 'react-router-dom'
import environment from 'constants/apiConst'
import { __PostForm, __Post } from 'request/Petitions/__Post'
import { __GetFormatSrt, __ShowForm } from 'request/Forms/__ShowForm'
import { AlertErrorAlert } from 'components/Alerts/AlertErrorAlert'
import { __GetItems } from 'request/Forms/_CrudForm'
import { HeaderSearch } from 'styled/SectionContainer.styled'
import { AttchmentTypiFied } from 'components/attchmentTypiFied/AttchmentTypiFied'
import Vapor from 'laravel-vapor'
import FormCrudCRUDContext from 'context/FormCrudContex'
import Swal from 'sweetalert2'
import DocumentUploader from 'pages/Entry_and_exit_forms/FormEntry/DocumentUploader/DocumentUploader'
import ModalFormatSRT from './ModalFormatSRT'
import GlobalContext from 'context/GlobalContext'
import TBodyAuthFormatSRT from './TBody/TBodyAuthFormatSRT'
import { ComparativeArray } from 'functions/ComparativeArray'
import { useStorageQuery } from 'hooks/useStorageQuery'
import { ButtonStyled } from 'styled/Buttons.styled'
import { isString } from 'utils/type-check-utils'

const thead = [
  { name: 'Item', order: 'null' },
  { name: 'Descripción', order: 'null' },
  { name: 'Referencia', order: 'null' },
  { name: 'Cantidad', order: 'null' },
  { name: 'Unidad Comercial', order: 'null' },
  { name: 'Acciones', order: 'null' }
]

const theadAuth = [
  { name: 'Item', order: 'null' },
  { name: 'Descripción', order: 'null' },
  { name: 'Cantidad', order: 'null' },
  { name: 'Unidad Comercial', order: 'null' },
  { name: 'Serial', order: 'null' },
  { name: 'Color', order: 'null' },
  { name: 'Estado', order: 'null' },
  { name: 'Característica Principal', order: 'null' },
  { name: 'Acciones', order: 'null' }
]

/** Adapta la respuesta del CDI al formato que espera la vista (antes solo FMM salida). */
const normalizeCdiInfo = raw => ({
  ...raw,
  code_outputForm: raw?.integration_certificate_code,
  status_outputForm: raw?.status,
  destination_address: raw?.destiny ?? raw?.destination_address,
  term:
    raw?.term ??
    raw?.number_days_extension ??
    (raw?.reentry_operation === 1 ? 'Temporal' : null) ??
    '—',
  expiration_final_date: raw?.expiration_final_date ?? '—'
})

/**
 * Plazo en FMM salida viene como `term` (= number_days_extension). Si viene vacío, se usa el mismo campo crudo.
 * En CDI no hay días de prórroga en cabecera; si el destino es temporal se muestra texto explícito.
 */
const formatPlazoLabel = (info, isCdi) => {
  const v = info?.term ?? info?.number_days_extension
  if (v !== undefined && v !== null && String(v).trim() !== '') {
    return String(v)
  }
  if (isCdi) {
    return info?.reentry_operation === 1 ? 'Temporal' : '—'
  }
  return '—'
}

const showSrtHeaderMeta = status =>
  status === 'AUTORIZADO' || status === 'APROBADO'

const FormatSRT = () => {
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [info, setInfo] = useState([])
  const [attachment, setAttachment] = useState([])
  const [attachmentDescription, setAttachmentDescription] = useState([])
  const [attachmentType, setAttachmentType] = useState([])
  const [files, setFiles] = useState({})
  const [nameFiles, setNameFiles] = useState([])
  const [reload, setReload] = useState(false)
  const { token } = useSelector(state => state.auth.dataUser)
  const { ExitNumber = '', FormType = '', Operation = '', Source = 'Salida' } =
    queryString.parse(location.search)
  const isCdi = Source === 'CDI'
  const { deleteAttachment, editDataForm, DocumentOperation, setRequestEdit } =
    useContext(FormCrudCRUDContext)
  const { idItemSRT, setiIdItemSRT, isOpen, setIsOpen } =
    useContext(GlobalContext)
  const [openAlert] = AlertErrorAlert()
  const navigate = useNavigate();
  const { admin, is_commerce, is_qualified_user } = useSelector((state) => state.auth.dataUser);
  const getInfo = async () => {
    setLoading(true)
    try {
      if (isCdi) {
        const formData = new FormData()
        formData.append('id', ExitNumber)
        const res = await __PostForm(
          environment.SHOW_INTEGRACION_BOX_ID,
          token,
          formData
        )
        if (res?.data?.status?.code === 200) {
          const raw = res?.data?.status?.data
          const result = normalizeCdiInfo(raw)
          setInfo(result)
          setAttachment(result?.other_files || [])
          const fileList = result?.files || []
          const fromServer = fileList.reduce((old, it) => {
            return {
              ...old,
              ['document-' + it.documentReq_id]: {
                name: it.attachment_name,
                document_id: it.documentReq_id,
                downloadFile: it.attachment_url,
                from_server: true,
                id: it.id
              }
            }
          }, {})
          setFiles(prev => ({
            ...prev,
            ...fromServer
          }))
        } else {
          openAlert(res?.data?.status?.message, 'error')
        }
      } else {
        const res = await __ShowForm(
          token,
          ExitNumber,
          environment.SHOW_FORM_EXIT
        )

        if (res?.data?.status.code === 200) {
          const result = res?.data?.status?.data
          setInfo(result)
          setAttachment(result?.other_files)
          const fromServer = (result.files || []).reduce((old, it) => {
            return {
              ...old,
              ['document-' + it.documentReq_id]: {
                name: it.attachment_name,
                document_id: it.documentReq_id,
                downloadFile: it.attachment_url,
                from_server: true,
                id: it.id
              }
            }
          }, {})
          setFiles(prev => ({
            ...prev,
            ...fromServer
          }))
        } else {
          openAlert(res?.data?.status.message, 'error')
        }
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const comparator = ComparativeArray(
      attachmentDescription,
      attachment,
      'other_attachment_description'
    )

    if (!comparator) {
      attachment?.forEach(item => {
        const newItem = item?.other_attachment_description
        if (newItem && !attachmentDescription.includes(newItem)) {
          setAttachmentDescription(prev => [...prev, newItem])
        }
      })
    }
  }, [attachment])

  const getData = async () => {
    try {
      if (isCdi) {
        const res = await __Post(
          `${environment.GET_PRODUCTS_CI}/${ExitNumber}`,
          token,
          { orderBy: 'ASC', length: 10000 }
        )
        if (res?.data?.status?.code !== 200) {
          return
        }
        const rows = res?.data?.status?.data?.data || []
        const statusRef = info?.status_outputForm
        const mapped = rows.map(row => ({
          ...row,
          item: row.item_code ?? row.item,
          description_product:
            row.description_product ||
            row.product_description ||
            row.item_description,
          quantity: row.quantity_product ?? row.quantity,
          unit_measurement: row.unit_measurement,
          srt_serial: row.srt_serial ?? null,
          srt_color: row.srt_color ?? null,
          status_srt: row.status_srt ?? null,
          srt_special_description: row.srt_special_description ?? null,
          status_entryForm: 'AUTORIZADO'
        }))
        mapped.sort((a, b) => {
          const ai = Number.parseInt(String(a.item), 10) || 0
          const bi = Number.parseInt(String(b.item), 10) || 0
          return ai - bi
        })
        setData(mapped)
        return
      }

      const formData = new FormData()
      formData.append('outputForm_id', ExitNumber)

      const endpoint = environment.GET_iTEM_EXIT
      const res = await __GetItems(
        token,
        formData,
        1,
        endpoint
      )

      const result = res?.data?.status?.data?.data
      if (!result?.length) {
        setData([])
        return
      }
      result.sort((a, b) => a.item - b.item)
      setData(result)
    } catch (error) { }
  }

  const handleFiles = (e, idFiles) => {
    e.preventDefault()
    document.getElementById(`${idFiles}`).click()
  }

  const handleFilesInput = e => {
    e.preventDefault()
    const name = e.target.name
    const Files = e.target.files
    const extensionOptions = [
      '.doc',
      '.docx',
      '.pdf',
      '.png',
      '.jpg',
      '.jpeg',
      '.gif',
      '.bmp',
      '.xls',
      '.xlsx',
      '.xlsm',
      'image/png',
      'image/*',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/pdf',
      'application/vnd.ms-excel'
    ]
  

    const getFileExtension =  files[0].name.split('.').pop()
    const fileExtension = isString(getFileExtension)
      ? getFileExtension.toLowerCase()
      : getFileExtension || "";

    const isValidExtension = extensionOptions.includes(`.${fileExtension}`)
    if (!isValidExtension) {
      const fileName = files[0].name
      return openAlert(
        `El archivo ${fileName} no es un tipo de archivo permitido.`,
        'error'
      )
    }
    Vapor.store(Files[0], {
      baseURL: environment.VAPOR_BASE_URL,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      setFiles(
        Object.assign(
          { ...files },
          {
            [e.target.id]: {
              file: response,
              name: Files[0].name,
              document_id: e.target.id.replace('document-', '')
            }
          }
        )
      )
      setNameFiles([...nameFiles, { name }])
    })
  }

  useEffect(() => {
    getInfo()
    if (!isCdi) {
      setRequestEdit(environment.UPDATE_FORM_EXIT)
    }
  }, []) // Remove isOpen dependency to prevent infinite loop

  // Separate useEffect to get data after info is loaded
  useEffect(() => {
    if (info && Object.keys(info).length > 0) {
      getData()
    }
  }, [info]) // Run getData when info changes

  // Separate useEffect to handle data refresh when needed
  useEffect(() => {
    if (reload) {
      getInfo()
      setReload(false)
    }
  }, [reload])

  // Add useEffect to refresh data when modal closes (optional enhancement)
  useEffect(() => {
    if (!isOpen && idItemSRT) {
      // Refresh data when modal closes to ensure latest information
      getData()
    }
  }, [isOpen, idItemSRT])

  const removeItemFromArr = (archivo, nombre) => {
    Swal.fire({
      title: `¿Estas seguro de eliminar el archivo "${nombre}"?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#1F7AC3',
      confirmButtonText: 'Eliminar',
      customClass: {
        title: 'class-text'
      }
    }).then(resultado => {
      if (resultado.isConfirmed) {
        if (files[archivo] !== undefined && files[archivo] !== null) {
          if (files[archivo].from_server) {
            deleteAttachment(
              environment.DELETE_ATTACHMENT_EXIT,
              files[archivo].id
            )
          }
          const obj = Object.assign({}, { ...files })
          if (obj[archivo] !== undefined && obj[archivo] !== null) {
            console.log(obj[archivo])
            delete obj[archivo]
          }
          setFiles(obj)
        }
      }
    })
  }

  const handleChangeOther = async () => {
    const formData = new FormData()
    formData.append('id', ExitNumber)

    if (attachment) {
      attachment.forEach(file => {
        if (!file.attachment_url) {
          formData.append('other_attachment[]', file)
        }
      })
    }

    if (attachmentDescription) {
      // attachmentDescription.forEach((descrip) => {
      formData.append(
        'other_attachment_description[]',
        attachmentDescription[0]
      )
      // });
    }
    if (attachmentType) {
      // attachmentType.forEach((type) => {
      formData.append('other_attachment_type[]', attachmentType[0])
      // });
    }
    const res = await editDataForm(formData, false)
    setReload(res)
    setAttachment([])
    setAttachmentDescription([])
    setAttachmentType([])
  }

  const isAuthorizationDeletedDocument =
    info?.status_outputForm !== 'BORRADOR' && (is_commerce === 1 || admin === 1 || is_qualified_user === 1)

  return (
    <div>
      <Center
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
          marginBottom: '20px'
        }}
      >
        {FormType === 'Ingreso' && (
          <Title>Consideraciones Adicionales Para Salidas Temporales Y Reingresos Formato SRT Para Reingresos de Temporales</Title>
        )}

        {FormType === 'Salida' && (
          <Title>Consideraciones Adicionales para Salidas Temporales
          </Title>
        )}

        {FormType === 'Pases' && (
          <Title>Consideraciones Adicionales para Reingresos
          </Title>
        )}

        <h2>{`No. ${info?.code_outputForm} - ${info?.name_qualified}`}</h2>
      </Center>

      {showSrtHeaderMeta(info?.status_outputForm) && (
        <Grid
          w='60%'
          templateRows='repeat(2, 1fr)'
          templateColumns='repeat(2, 1fr)'
          gap={8}
          pb={10}
        >
          <GridItem colSpan={1}>
            <Text fontSize='sm' as='b'>
              Tipo de Operación:
            </Text>
            {FormType === 'Ingreso' || FormType === 'Pases'
              ? (
                <Text>{Operation}</Text>
              )
              : (
                <Text>{`${info?.code_operation} - ${info?.short_name_operation}`}</Text>
              )}

          </GridItem>
          <GridItem colSpan={1}>
            <Text fontSize='sm' as='b'>
              Plazo:
            </Text>
            <Text>{formatPlazoLabel(info, isCdi)}</Text>
          </GridItem>
          <GridItem colSpan={1}>
            <Text fontSize='sm' as='b'>
              Dirección Destino:
            </Text>
            <Text>{info?.destination_address}</Text>
          </GridItem>
          <GridItem colSpan={1}>
            <Text fontSize='sm' as='b'>
              Plazo de vencimiento:
            </Text>
            <Text>{info?.expiration_final_date}</Text>
          </GridItem>
        </Grid>
      )}

      <Title>Ítems del formulario</Title>
      {info?.status_outputForm === 'APROBADO' && !isCdi
        ? (
          <TableOrder
            thead={thead}
            data={data}
            setData={setData}
            loading={loading}
            tbodyData={TBodyFormatSRT}
          />
        )
        : (
          <TableOrder
            thead={theadAuth}
            data={data}
            setData={setData}
            loading={loading}
            tbodyData={(props) => (
              <TBodyAuthFormatSRT
                {...props}
                status_outputForm={info?.status_outputForm}
                isCdi={isCdi}
              />
            )}
          />
        )}

      {/* Enhanced SRT Modal with stabilization */}
      {isOpen && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          backgroundColor: 'rgba(0, 0, 0, 0.5)', 
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '90%',
            maxHeight: '90%',
            overflow: 'auto',
            position: 'relative'
          }}>
            {/* Close button */}
            <button
              onClick={() => setIsOpen(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666',
                fontWeight: 'bold'
              }}
              title="Cerrar modal"
            >
              ×
            </button>
            <ModalFormatSRT />
          </div>
        </div>
      )}

      {!isCdi && DocumentOperation.length > 0 && (
        <HeaderSearch>
          {DocumentOperation.map((document, index) => (
            <div key={index}>
              <DocumentUploader
                document={document}
                handleFiles={handleFiles}
                handleFilesInput={handleFilesInput}
                handleDelete={removeItemFromArr}
                files={files}
                setNameFiles={setNameFiles}
                nameFiles={nameFiles}
                index={index}
                viewBtnDelete={isAuthorizationDeletedDocument}
              />
            </div>
          ))}
        </HeaderSearch>
      )}

      {!isCdi && (
        <HeaderSearch>
          <AttchmentTypiFied
            titulo={'Otros documentos'}
            attachment={attachment}
            setAttachment={setAttachment}
            attachmentDescription={attachmentDescription}
            setAttachmentDescription={setAttachmentDescription}
            attachmentType={attachmentType}
            setAttachmentType={setAttachmentType}
            deleteAttachment={deleteAttachment}
            ruta={environment.DELETE_OTHER_ATTACHMENT_EXIT}
            viewBtn={true}
            viewBtnDelete={isAuthorizationDeletedDocument}
            update={handleChangeOther}
          />
        </HeaderSearch>
      )}

      {
        FormType === "Pases" && (<ButtonStyled onClick={() => navigate(`/FormShowExit?ExitNumber=${ExitNumber}`)}>Ir al Formulario de Salida</ButtonStyled>)
      }
      {
        (FormType === "Ingreso" || FormType === "Salida") && (<ButtonStyled onClick={() => navigate(-1)}>Ir atrás</ButtonStyled>)
      }

    </div>
  )
}

export default FormatSRT
